import Home from "@/pages/Home";
import ArrivalShow from "@/pages/ArrivalShow";
import LoadingShow from "@/pages/LoadingShow";
import BatchShow from "@/pages/BatchShow";
import NotFound from "@/pages/NotFound";
import {createRouter, createWebHistory} from 'vue-router'
import IncomingPage from "@/pages/IncomingPage";
import DryingPage from "@/pages/DryingPage";
import StockPage from "@/pages/StockPage";
import BatchPage from "@/pages/BatchPage";
import LoadingPage from "@/pages/LoadingPage";
import NotesPage from "@/pages/NotesPage";
import SignIn from "@/pages/SignIn";
import OverviewPage from "@/pages/OverviewPage";
import BigBagPage from "@/pages/BigBagPage";
import ContactPage from "@/pages/ContactPage";
import ProductPage from "@/pages/ProductPage";
import SettingPage from "@/pages/SettingPage";
import ResetPassword from "@/pages/ResetPassword";
import store from '@/store'
import TestScale from "@/pages/TestScale";
import BatchView from "@/pages/BatchView.vue";

const routes = [
    {
        path: '/',
        name: 'Home',
        component: Home,
        meta: {title:'', permission: 'read', toTop: true, smoothScroll: true}
    },
    {
        path: '/incoming',
        name: 'IncomingPage',
        component: IncomingPage,
        meta: {title:'Chargen', permission: 'read', toTop: true, smoothScroll: true}
    },
    {
        path: '/drying',
        name: 'DryingPage',
        component: DryingPage,
        meta: {title:'Chargen', permission: 'read', toTop: true, smoothScroll: true}
    },
    {
        path: '/stock',
        name: 'StockPage',
        component: StockPage,
        meta: {title:'BigBags', permission: 'read', toTop: true, smoothScroll: true}
    },
    {
        path: '/loading',
        name: 'LoadingPage',
        component: LoadingPage,
        meta: {title:'Lieferungen', permission: 'read', toTop: true, smoothScroll: true}
    },
    {
        path: '/notes',
        name: 'NotesPage',
        component: NotesPage,
        meta: {title:'Notizen & Fotos', permission: 'read', toTop: true, smoothScroll: true}
    },
    {
        path: '/overview',
        name: 'OverviewPage',
        component: OverviewPage,
        meta: {title:'Übersicht', permission: 'admin', toTop: true, smoothScroll: true}
    },
    {
        path: '/bigbag/:supplierId?/:regraterId?',
        name: 'BigBagPage',
        component: BigBagPage,
        props: true,
        meta: {title:'Übersicht', permission: 'admin', toTop: true, smoothScroll: true}
    },
    {
        path: '/contact',
        name: 'ContactPage',
        component: ContactPage,
        meta: {title:'Kontake', permission: 'admin', toTop: true, smoothScroll: true}
    },
    {
        path: '/product',
        name: 'ProductPage',
        component: ProductPage,
        meta: {title:'Produkte', permission: 'admin', toTop: true, smoothScroll: true}
    },
    {
        path: '/setting',
        name: 'SettingPage',
        component: SettingPage,
        meta: {title:'Einstellungen', permission: 'admin', toTop: true, smoothScroll: true}
    },
    {
        path: '/test-scale',
        name: 'TestScale',
        component: TestScale,
        meta: {title:'Test: Waage', permission: 'admin', toTop: true, smoothScroll: true}
    },
    {
        path: '/batch',
        name: 'BatchPage',
        component: BatchPage,
        meta: { title:'Chargen', permission: 'read', toTop: true, smoothScroll: true }
    },
    {
        path: '/batch/:id',
        name: 'BatchShow',
        component: BatchShow,
        props: true,
        meta: {title:'Charge', permission: 'read', toTop: true, smoothScroll: true}
        // beforeEnter(to, from, next) {
        //     const batch = store.dispatch('getBatch', to.params.id)
        //
        //     if (batch) {
        //         return next()
        //     } else {
        //         next({
        //             name: 'NotFound',
        //             pathMatch: to.substring(1).split('/'),
        //             query: to.query,
        //             hash: to.hash
        //         })
        //     }
        // }
    },
    {
        path: '/batch/view/:id',
        name: 'BatchView',
        component: BatchView,
        props: true,
        meta: { title:'Charge', permission: 'read', toTop: true, smoothScroll: true }
    },
    {
        path: '/loading/:id',
        name: 'LoadingShow',
        component: LoadingShow,
        meta: {title: 'Verladen', toTop: true, permission: 'read', smoothScroll: true},
        props: true
    },
    {
        path: '/arrival/:id',
        name: 'ArrivalShow',
        component: ArrivalShow,
        meta: {toTop: true, permission: 'read', smoothScroll: true},
        props: true
    },
    {
        path:'/signin',
        name:'SignIn',
        component: SignIn,
        meta: {toTop: true, smoothScroll: true}
    },
    {
        path:'/reset-password/:hash',
        name:'ResetPassword',
        component: ResetPassword,
        props: true,
        meta: {toTop: true, smoothScroll: true}
    },
    {
        path: '/:pathMatch(.*)*',
        name: 'NotFound',
        component: NotFound
    }
]

const router = createRouter({
    history: createWebHistory(),
    routes,
    scrollBehavior(to) {
        const scroll = {}
        if (to.meta.toTop) scroll.top = 0
        if (to.meta.smoothScroll) scroll.behavior = 'smooth'

        return { scroll }
    }
})

router.beforeEach(async function(to,from,next) {
    // validate login and permission

    await store.dispatch('setAPIconf')
    await store.dispatch('tryLogin')

    let userHasPermission = true
    switch (to.meta.permission) {
        case 'admin':
            userHasPermission = store.getters.isAdmin
            break
        case 'read':
            userHasPermission = parseInt(store.getters.userId) > 0
            break
    }
     // console.log(store.getters,store.getters['userId'],store.getters.isAdmin,'hasPerm',userHasPermission)
    if (userHasPermission) {
        await store.dispatch('setTitle', to.meta.title)
        next()
    } else next('/signin')
})

export default router